import {useUser} from "../../utils/hooks"


export const Debug = ({data}) => <pre>{JSON.stringify(data, null, 2)}</pre>

export const UserDebug = () => {
	const loggedInUser = useUser()
	return <Debug data={loggedInUser} />
}
